module.exports = {
	"help": "Help",
	"productsAndServices": {
		"buying": "Buying on __brand__",
		"features": "$t(features::header)",
		"header": "Products & Services",
		"selling": "Selling on $t(general::brand)",
		"pricing": "Pricing"
	},
	"about": {
		"aboutUs": "About $t(general::brand)",
		"header": "About",
		"privacy": "Privacy"
	},
	"community": {
		"header": "Community"
	},
	"OSTimezone": "OS Timezone"
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/footer.json5
// module id = 1931
// module chunks = 6